module.exports = __webpack_public_path__ + "static/headshot-forest-monsen.dcb006d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-forest-monsen.jpg
// module id = 521
// module chunks = 152909308826437